const Skills = [
	{
		name: 'Google Cloud (Pub/Sub, Function, Cloud Run, Firestore)',
		rating: 4
	},
	{
		name: 'IaC (Terraform, ARM, CloudFormation)',
		rating: 4
	},
	{
		name: 'Automation (Python, NodeJS)',
		rating: 4
	},
	{
		name: 'Azure ( Functions, Runbooks, CosmosDB)',
		rating: 3.5
	},
	{
		name: 'AWS (EC2, Alexa, Lambda, IAM, S3)',
		rating: 3
	},
	{
		name: 'DevOps (Jenkins, Azure Devops, Github Actions)',
		rating: 3
	}
];

export default Skills;
